// src/store/slices/themeSelecionadoSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface ThemeSelecionadoState {
  theme: string | null;
}

const initialState: ThemeSelecionadoState = {
  theme: null
};

const themeSelecionadoSlice = createSlice({
  name: 'themeSelecionado',
  initialState,
  reducers: {
    setThemeSelecionado(state, action: PayloadAction<string>) {
      state.theme = action.payload;
    },
    resetThemeSelecionado(state) {
      state.theme = null;
    }
  }
});

export const { setThemeSelecionado, resetThemeSelecionado } = themeSelecionadoSlice.actions;
export default themeSelecionadoSlice.reducer;


